<div *transloco="let t" class="bg-black h-[100svh] w-screen flex items-center place-content-center">
    <img (click)="goHome()" src="./assets/logo.png" class="fixed h-10 cursor-pointer top-2 left-2">
    <div class="w-fit text-[40px] font-bold text-white">{{t('404Message')}}</div>
</div>
